export default [
  {
    path: '/screen-equipment',
    name: 'ScreenDevice',
    component: resolve => require(['@/views/ScreenDevice'], resolve)
  }
]
